import { backgroundColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const MIN_BUTTON_WIDTH = 100;
const BUTTON_MARGIN = 10;

const singleAccordionRowStyle = (theme) => ({
	singleAccordionRowWrapper: {
		padding: '10px 24px',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexWrap: 'wrap',
		borderBottom: `2px solid ${backgroundColor[0]}`,
		[theme.breakpoints.down('sm')]: {
			padding: '10px 16px',
			alignItems: 'flex-start',
		},
	},
	singleAccordionRowNameAndTooltipWrapper: {
		flexBasis: 0,
		flexGrow: 2,
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	singleAccordionRowStatusAndButtonsWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		flexBasis: 0,
		flexGrow: 2,
		[theme.breakpoints.down('sm')]: {
			flexDirection: 'column',
			alignItems: 'flex-end',
			flexBasis: 'initial',
			flexGrow: 'initial',
		},
	},
	singleAccordionRowButtonsWrapper: ({ numberOfButtons }) => ({
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
		minHeight: 40,
		minWidth:
			numberOfButtons > 0
				? numberOfButtons * MIN_BUTTON_WIDTH + (numberOfButtons - 1) * BUTTON_MARGIN
				: MIN_BUTTON_WIDTH,
		'& button': {
			margin: 0,
			'&:first-of-type': {
				marginRight: BUTTON_MARGIN,
			},
			'&:last-of-type': {
				marginRight: 0,
			},
		},
		[theme.breakpoints.down('sm')]: {
			paddingTop: 12,
			minWidth: 0,
		},
	}),
	singleAccordionRowDescriptionWrapper: {
		width: '100%',
		'& p': {
			maxWidth: 400,
			paddingTop: 5,
			paddingBottom: 5,
			whiteSpace: 'pre-line',
		},
	},
	tooltip: {
		display: 'inherit',
	},
	singleAccordionRowStatusAndDateWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	singleAccordionRowDateWrapper: {
		paddingRight: 15,
		display: 'inline',
		'& p': {
			display: 'inline',
		},
	},
	singleAccordionRowBadge: {
		minWidth: 100,
	},
	singleAccordionButton: {
		minWidth: 100,
	},
	singleAccordionButtonBorder: {
		border: `1px solid ${primaryColor[0]}`,
	},
});

export default singleAccordionRowStyle;
